// extracted by mini-css-extract-plugin
export default {"container":"loader_container__a3U5q","loader":"loader_loader__UQ49D","circle":"loader_circle__XNi4s","preloader":"loader_preloader__EcohU"};